import { BREADCRUMB } from '../constants/staticText'

// Der Weg zur aktuellen Seite, als Stationen von aussen nach innen.
//
// Die letzte Station traegt kein Ziel: ein Verweis auf die eigene Seite fuehrt
// nirgendwohin. Auf einer Abschnittsseite wandert das Ziel darum an die Messe —
// dort liegt der Rueckweg zu den Kacheln, die es in der Abschnitts-View nicht
// mehr gibt (#82).
//
// Der Start liegt ausserhalb der React-App. Ohne die Kennzeichnung wuerde
// react-router '/' als App-Route behandeln und die WordPress-Startseite nie
// erreichen.
// Die Uebersicht selbst: nur Start und die eigene Station — dieselbe Leiste
// wie auf den Unterseiten, der Ort ist die Events-Seite (#82).
export const overviewTrail = () => [
    { label: BREADCRUMB.start, to: '/', extern: true },
    { label: BREADCRUMB.events }
]

const eventTrail = (event, tile) => {
    if (!event) return []

    const abschnitt = tile && tile.title

    return [
        { label: BREADCRUMB.start, to: '/', extern: true },
        { label: BREADCRUMB.events, to: '/events/' },
        abschnitt
            ? { label: event.name, to: `/events/${event.slug}/` }
            : { label: event.name },
        ...abschnitt ? [{ label: tile.title }] : []
    ]
}

export default eventTrail
